export default __webpack_public_path__ + "static/media/resourcesBlueDown.d16e4faa.svg";